"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("../packages/component-library/node_modules/react-is/index.js");var r=e.__require();exports.reactIsExports=r;
//# sourceMappingURL=index5.js.map
